import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { comics } from '@/mocks/comics';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  const tabs = [
    { slug: 'all', name: '全部' },
    { slug: 'korean', name: '韩漫' },
    { slug: 'japanese', name: '日漫' },
    { slug: 'chinese', name: '国漫' },
    { slug: 'romance', name: '恋爱' },
    { slug: 'fantasy', name: '奇幻' },
    { slug: 'action', name: '热血' },
    { slug: 'comedy', name: '搞笑' },
    { slug: 'completed', name: '已完结' },
  ];

  const filteredComics = activeCategory === 'all'
    ? comics
    : comics.filter((c) => c.category === activeCategory || c.subCategory === activeCategory || (activeCategory === 'completed' && c.status === 'completed'));

  return (
    <section className="py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            漫画大全
          </h2>
          <Link
            to={`/category/${activeCategory}`}
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer font-medium"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="flex items-center gap-2 mb-8 overflow-x-auto scrollbar-hide pb-2">
          {tabs.map((tab) => (
            <button
              key={tab.slug}
              onClick={() => onCategoryChange(tab.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                activeCategory === tab.slug
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
          {filteredComics.slice(0, 12).map((comic) => (
            <ComicCard key={comic.id} {...comic} />
          ))}
        </div>
      </div>
    </section>
  );
}